import { styled } from 'styled-components'

export const LineItemPriceContainer = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: end;
  text-align: right;
`
